module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Kode Voucher',
          to: {
            path: '/kode-voucher'
          }
        },
        {
          text: 'Detail Kode Voucher'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n                    Detail Kode Voucher\n                ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pr-2 pt-4 text-right",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateVoucherCode()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("mdi-pencil")]), _vm._v("\n                    Edit\n                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-8"
  }, [_c('v-row', {
    staticClass: "mt-2 mb-4"
  }, [_c('v-col', {
    staticClass: "pt-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Nama Voucher\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    Diskon Gedee Biar MAKIN AMBISS\n\n                                    "), _c('v-btn', {
    staticClass: "green--text ml-3",
    attrs: {
      "color": "#e2f5ea",
      "depressed": "",
      "rounded": ""
    }
  }, [_vm._v("\n                                        Aktif\n                                    ")])], 1)])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Periode Voucher\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    2024-01-17 s/d 2024-02-30\n                                ")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Paket Belajar\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    TRYOUT SATUAN AMBIS SNBT/UTBK 2024\n                                    EPISODE 05, PAKET KONSULTASI 1 SESI (30\n                                    Menit)\n                                ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Persen Diskon\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    20%\n                                ")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "mr-2 font-weight-700"
  }, [_vm._v("GFVLGION")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "color": "#e2f0f7",
      "depressed": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                                mdi-clipboard-outline\n                            ")]), _vm._v("\n                            Copy\n                        ")], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 mt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Jumlah Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            88 "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Voucher")])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("\n                            Total Voucher Digunakan\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            3 "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Voucher")])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Sisa Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            85 "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Voucher")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Daftar Kode Voucher ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "has-action": false,
      "has-export": true,
      "has-duplicate": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = $event.value;
        _vm.tableKey = $event.key.value;
        _vm.doSearch();
      }
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-7",
    attrs: {
      "color": "#ec675e",
      "dark": "",
      "depressed": "",
      "large": ""
    }
  }, [_vm._v("\n        Nonaktifkan Kode Voucher\n    ")]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab525280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/VoucherCodeDetail.vue
// module id = 2053
// module chunks = 1